import Swiper from 'swiper'
import { Pagination, Autoplay } from 'swiper/modules'

export default (function () {
    document.querySelectorAll('[data-module="usp-carousel"]').forEach((instance) => {
        const isNested = instance.closest('.wp-block-column')
        const isArchive = instance.classList.contains('on-archive')
        let options = {
            modules: [Pagination, Autoplay],
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            centerInsufficientSlides: true,
            pagination: {
                enabled: true,
                clickable: true,
                el: '.swiper-pagination',
            },
            breakpoints: {
                992: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 4,
                    pagination: false,
                    allowTouchMove: false,
                },
            },
        }

        if (isNested) {
            options = {
                ...options,
                breakpoints: {
                    782: {
                        slidesPerView: 'auto',
                        direction: 'vertical',
                        pagination: false,
                        allowTouchMove: false,
                    },
                },
            }
        }

        if (isArchive) {
            options = {
                ...options,
                loop: true,
                autoplay: true,
                pagination: false,
                breakpoints: {
                    992: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                },
            }
        }

        // eslint-disable-next-line no-new
        new Swiper(instance, options)
    })
})
